import React from 'react'
import PropTypes from 'prop-types'
import { CustomBadge } from '../components/Shared'
import { Link } from 'react-router-dom'
import { translate } from '../cls/TranslationContext'

const keyInObjectAndValue = (obj, key, value) => {
	if (key in obj) {
		// obj[key] might not be boolean and our interest could be if it has value
		if (typeof obj[key] === 'boolean') {
			return obj[key] === value
		} else if (typeof obj[key] === 'string') {
			return obj[key] === value
		} else if (Array.isArray(obj[key])) {
			return obj[key].includes(value)
		} else {
			return true
		}
	}
}

// Validate the route based on the user's permissions and the app type
export const validateRoute = (route, stores, collapsed) => {
	const { users, appType } = stores
	const { appIsClient, appIsTeam } = appType
	const { loggedInUser } = users

	const isSuperAdmin = loggedInUser.isSuperAdmin

	if (!route?.label) return null
	if (keyInObjectAndValue(route, 'loggedInDisable', true) && users.isLoggedIn)
		return null

	if (keyInObjectAndValue(route, 'loggedInActive', true) && !users.isLoggedIn)
		return null
	if (keyInObjectAndValue(route, 'superAdminActive', true) && !isSuperAdmin)
		return null

	if (keyInObjectAndValue(route, 'appType', 'client') && !appIsClient)
		return null

	if (keyInObjectAndValue(route, 'appType', 'team') && !appIsTeam) return null
	if (keyInObjectAndValue(route, 'published', false)) return null
	if (keyInObjectAndValue(route, 'checkPermission', true) && !route.table)
		return null

	if (
		keyInObjectAndValue(route, 'superAdminVersionOverride', true) &&
		isSuperAdmin
	) {
		// console.log('superAdminVersionOverride', route)
	} else {
		// console.log('Version limit check', route)
		if (keyInObjectAndValue(route, 'showUntilVersion', false)) return null
		if (keyInObjectAndValue(route, 'requiredVersion', false)) return null
	}

	const RouteWithBadge = ({ count, children }) => {
		return count > 0 ? (
			<CustomBadge
				className="anticon"
				offset={[3, 0]}
				count={count}
				dot={true}
			>
				{children}
			</CustomBadge>
		) : (
			children
		)
	}

	RouteWithBadge.propTypes = {
		count: PropTypes.number,
		children: PropTypes.node
	}

	const showCount = (key) => {
		switch (key) {
			case 'notifications':
				return stores.uiLstNotifications.nr || 0
			default:
				return 0
		}
	}

	const item = {
		key: route.key,
		keyparent: route?.keyparent || null,
		label:
			route?.loggedInActiveLabel && !users.isLoggedIn ? (
				''
			) : route?.path ? (
				<Link to={route.path}>{translate(route.label)}</Link>
			) : (
				translate(route.label)
			),
		className: route?.className || null,
		icon: route?.icon ? (
			<RouteWithBadge count={showCount(route.key)}>
				<route.icon className="side-menu-icon" />
			</RouteWithBadge>
		) : null,
		type: route?.type || null
	}

	if (route.children) {
		const validChildren = route.children
			.map((child) => validateRoute(child, stores, collapsed))
			.filter((child) => child !== null)

		if (validChildren.length) {
			if (collapsed && route.collapsedTitle) {
				const groupKey = route.key + '-group'
				const validChildrenWithGroupKey = validChildren.map(
					(child) => ({
						...child,
						icon: null,
						keyparent: groupKey
					})
				)
				item.children = [
					{
						key: groupKey,
						keyparent: route?.keyparent || null,
						id: 'children-' + (item?.id || ''),
						label: translate(route.label),
						type: 'group',
						children: validChildrenWithGroupKey
					}
				]
			} else {
				item.children = validChildren
			}
		} else {
			return null
		}
	}

	return item
}

/**
 * Determine the current selected menu item based on the current path
 * @param {Array} routes - The array of routes
 * @param {Object} location - The location object from react-router-dom
 * @returns {Array} - The selected key or keys (when parent and child are selected)
 */
export const selectedRouteKey = (routes, location) => {
	const path = location.pathname
	const route = routes.find((r) => r.path === path)
	if (!route) return []

	if (route?.keyparent) {
		return [route.keyparent, route.key]
	}
	return [route.key]
}
